import io from 'socket.io-client';
import authService from './auth-service';

const isProduction = process.env.REACT_APP_NODE_ENV === '\'production\'';
const isStaging = process.env.REACT_APP_NODE_ENV === '\'staging\'';
const isDevelopment = process.env.NODE_ENV === 'development';

const constants = {
  WEBSOCKET_ENDPOINT_PROD: process.env.REACT_APP_BACKEND || '',
  WEBSOCKET_ENDPOINT_STAGING: process.env.REACT_APP_BACKEND_STAGING || '',
  WEBHOOK_ENDPOINT_DEV: 'localhost:3017'
};

export class WebsocketService {
  connect() {
    if (isProduction) {
      this.endpoint = constants.WEBSOCKET_ENDPOINT_PROD;
    } else if (isStaging) {
      this.endpoint = constants.WEBSOCKET_ENDPOINT_STAGING;
    } else if (isDevelopment) {
      this.endpoint = constants.WEBHOOK_ENDPOINT_DEV;
    }
    if (this.endpoint && authService.token) {
      this.socket = io(this.endpoint, { path: '/websocket' });
      this.socket.on('connect', () => {
        console.log('Socket connected');
        this.socket.emit('authentication', { token: authService.token });
        this.socket.on('authenticated', () => {
          console.log('Socket authenticated!');
        });
      });
      this.socket.on('connect_error', (err) => console.log('Socket connect error', err));
      this.socket.on('connect_timeout', (timeout) => console.log('Socket connect timeout', timeout));
      this.socket.on('error', (err) => console.log('Socket error', err));
      this.socket.on('disconnect', (reason) => console.log(`Socket disconnected: ${reason}`));
      this.socket.on('unauthorized', (err) => {
        console.log('There was an error with the socket authentication:', err.message);
      });
      return this.socket;
    }
    return null;
  }

  disconnect() {
    if (this.socket && this.socket.connected) this.socket.disconnect();
  }
}

export default new WebsocketService();


// WEBPACK FOOTER //
// ./src/services/websocket-service.js